import { getGroupBoardingFilter } from "../../redux/Actions";

export const urls = {
  LoginCall: `/APILogInValidationV10`,
  getTodayTomorrowScheduleDataList: '/MavenTripDetailsDashboard',
  getCityList: '/APIGetCompanyCityPairs',
  getSearchedTripList: '/APISearchRoutesCRSAPP',
  getSeatChart: '/APIGetChartLayoutWithFareV2',
  getGuestTypeList: '/APIGuestTypeListAll',
  getAgentList: '/APIGetAllAgentsList',
  getBranchList: '/APIGetBranchListAll',
  getBranchUserList: '/APIGetUserListAll',
  getPickupLocation: '/APIGetTripPickupsV2',
  getDropoffLocation: '/APIGetTripDropoffsV2',
  cashBasedBooking: '/APIBookingsInsertUpdateV9',
  getBookingTypesColors: '/APIGetCompanyBookingTypesColors',
  getSubRoutesCity: '/APIMavenTripSubRoutesFaresLuggageFare',
  getBusesListAll: '/APIBusesListAll',
  getDriverListAll: '/APIDriverConductorListAll',
  getConductorListAll: '/APIDriverConductorListAll',
  getPickupManListAll: '/APIPickupManListAll',
  busScheduleInsertUpdate: '/BusScheduleInsertUpdate',
  mavenDevices: '/APIDeactivateMavenByUser',
  getHasServiceTax: '/HasServiceTax',
  getCompanyServicetax: '/GetCompanyServicetax',
  getConcessionTypes: '/APIMavenGetPunbusConcessionTypes',
  getCouponCardList: '/MavenCouponCardListAll',
  updateCoupon: '/MavenRedeemCoupon',
  validateCouponOTP: '/MavenvalidateCouponOTP',
  updateSpecialQuota: '/SpecialQuotaSaveV2',
  updateBookingsModifyWithNameChange: '/BookingsModifyWithNameChange',
  getBookingsCancelV2: '/APIBookingsCancelV2',
  updateBookingsModify: '/BookingsModify',
  sendEmail: '/SendEmail',
  reSendSMS: "/ReSendSMS",
  getBookingInquiryRptData: '/APIGetReportV2',
  sendGPSSMS: '/APISendGPSSMS',
  APIMavenCutRootFareSchedule: '/APIMavenCutRootFareSchedule',
  phoneCnfrm: "/BookingsModifyV3",
  getGenerateOTPForCancelChart: '/APIMavenGenerateOTPForCancelChart',
  getValidateOTP: '/APIMaveenValidateOTP',
  updateCancelTicketForChartCancel: '/APIMavenCancelTicketForChartCancel',

  //Report 
  getQuickView: '/ApiQuickView',
  getQuickViewDetail: '/APIQuickViewForMaven',
  getUserWiseCollSummary: '/APIMavenBookingsUserWiseCollSummary',
  getTripList: '/APIMavenTripsListAll',
  getBookingSummary: '/APIGetInquiry3ReportDatewiseMAVEN',
  getSearchPNR: '/APIBookingsLoad',


  getPaymentMode: '/APIRechargePaymentModesListAll',
  updateAgentRecharges: '/APIAgentRechargesInsert',

  sendSMSForChartTransfer: '/SendSMSForChartTransfer',
  getChartLayout: '/MavenAPIGetChartLayout',
  updateArrgTransferNew: '/MavenBookingsArrgTransferNew',
  sendSMSForArrangementTransfer: '/MavenSendSMSForArrangementTransfer',

  getGroupBoardingFilter: '/APIMavenGroupboardingFilters',
  getGroupBoardingReportData: '/MavenAPIGroupBoardingReportData',
  sendGroupBoardingSms: '/MavenAPIsendGroupBoardingSMS',

  updatePNRBoardedSeatWise: '/APIUpdatePNRBoardedSeatWise',
  getCompanyAmenitiesAll: '/APIGetCompanyAmenitiesAll',
  getTripsConfiguredDetailsList: '/APIMavenTripsConfiguredDetailsList',
  updateTripSchedule: '/APIMavenTripSchedule',
  getPkpInquiryPDF: '/APIMavenGetPkpInquiry',
  getTridDetailsByTripId:'/MavenTripDetails',
  SendPickupSMS:'/APIPickupwiseSMS',
  getRoleRightsConfig:'/APIRoleRightsConfigListAll'
};
const cargoBaseUrl = 'https://cargoapi.mavenconnect.biz'
export const cargoUrl = {
  getCargoSetting: `${cargoBaseUrl}/api/GetCargoSetting`,
  branchAndPartyRecharge: `${cargoBaseUrl}/api/BranchRechargeRequest/Post`,
  QRPaymentDetailsInsert: `${cargoBaseUrl}/api/BranchRechargeRequest/QRPaymentDetailsInsert`,
  QrAccountDetails: `${cargoBaseUrl}/api/BranchRechargeRequest/GetDQRAccountDetails?`,
  BranchDetails: `${cargoBaseUrl}/api/Common/BranchesListAll?`,
  BranchRechargesInsertConfirm: `${cargoBaseUrl}/api/BranchRechargesInsertConfirm`,
  BranchRechargesReject: `${cargoBaseUrl}/api/BranchRechargesReject`,
};

export const isEmpty = (obj) => {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};



export const dummLogin = {
  "CompanyConfiguration": [
    {
      "AllowMultipleQRTransactions": 1,
      "AllowNonReportOnPhnBkg": 1,
      "BaseCurrencyCode": "Rs.",
      "BaseCurrencyID": 1,
      "BusLogo": null,
      "CargoIsSharedCompany": 0,
      "CargoLogo": null,
      "CargoParentCompanyID": 1,
      "DefaultCountryCode": "+91",
      "Denomination": 1,
      "DoNotShowChartLayoutInMaven": 1,
      "IgnoreStageClosing": 1,
      "IsAllowPhoneMinFare": 1,
      "IsAutoFillPaxDetails": 1,
      "IsAutoPosBus": 1,
      "IsAutoPosBushire": 1,
      "IsAutoPosCargoBkg": 1,
      "IsAutoPosFTL": 1,
      "IsBoardingOTP": 1,
      "IsBoardingPinEnabled": 1,
      "IsPaxDetailInfo": 0,
      "IsTabletunassignmentAllow": 0,
      "MobNoLLimit": 6,
      "MobNoULimit": 10,
      "OTPBackdateCancelType": "BackDateSameDateBkgs",
      "PNRCancelOTPNo": "8655122152"
    }
  ],
  "CompanyCurrencyList": [
    {
      "CurrencyCode": "KSH",
      "CurrencyID": 2
    }
  ],
  "CountryCodeList": [
    {
      "CountryCode": "+211"
    },
    {
      "CountryCode": "+242"
    },
    {
      "CountryCode": "+243"
    },
    {
      "CountryCode": "+249"
    },
    {
      "CountryCode": "+250"
    },
    {
      "CountryCode": "+251"
    },
    {
      "CountryCode": "+252"
    },
    {
      "CountryCode": "+253"
    },
    {
      "CountryCode": "+254"
    },
    {
      "CountryCode": "+255"
    },
    {
      "CountryCode": "+256"
    },
    {
      "CountryCode": "+257"
    },
    {
      "CountryCode": "+265"
    }
  ],
  "ErrorMessage": "User logged in Successfully",
  "RoleDetails": [
    {
      "JobDescription": "Luggage Booking",
      "JobID": 53,
      "JobName": "Luggage Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Report V2",
      "JobID": 465,
      "JobName": "Booking Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Collection",
      "JobID": 62,
      "JobName": "Userwise Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Analysist Report",
      "JobID": 90,
      "JobName": "Analysis Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quick View",
      "JobID": 36,
      "JobName": "Quick View",
      "RoleID": 23827
    },
    {
      "JobDescription": "Goods Balance",
      "JobID": 190,
      "JobName": "Goods Balance",
      "RoleID": 23827
    },
    {
      "JobDescription": "Received Report V3",
      "JobID": 461,
      "JobName": "Received Report V3",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Collection",
      "JobID": 35,
      "JobName": "Userwise Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quick View",
      "JobID": 65,
      "JobName": "Quick View",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Branch Collection",
      "JobID": 93,
      "JobName": "Daily Branch Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "BranchWise Collection",
      "JobID": 56,
      "JobName": "Branchwise Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Non-Movement Report V3",
      "JobID": 464,
      "JobName": "Non-Movement Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quick View Dashboard",
      "JobID": 162,
      "JobName": "Quick View Dashboard",
      "RoleID": 23827
    },
    {
      "JobDescription": "Agent Tickets(with cancellations)",
      "JobID": 58,
      "JobName": "Agent Tickets",
      "RoleID": 23827
    },
    {
      "JobDescription": "Ticket Modify",
      "JobID": 38,
      "JobName": "Ticket Modify",
      "RoleID": 23827
    },
    {
      "JobDescription": "Route CheckList(Konduskar)",
      "JobID": 121,
      "JobName": "Route CheckList",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise Collection(Agent and Branch Comm)",
      "JobID": 183,
      "JobName": "Buswise Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise Collection and Expenses",
      "JobID": 184,
      "JobName": "Buswise Collection and Expenses",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee Collection (STax on CC)",
      "JobID": 181,
      "JobName": "Franchisee Collection (STax on CC)",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee Collection",
      "JobID": 45,
      "JobName": "Franchisee Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Card and Wallet Transactions",
      "JobID": 46,
      "JobName": "Card and Wallet Transactions",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cancellations",
      "JobID": 49,
      "JobName": "Cancellations",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branchwise Collection (STax on CC)",
      "JobID": 182,
      "JobName": "Branchwise Collection (STax on CC)",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branchwise Collection Summary",
      "JobID": 96,
      "JobName": "Branchwise Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "CSV Export",
      "JobID": 79,
      "JobName": "CSV Export",
      "RoleID": 23827
    },
    {
      "JobDescription": "Removed Quota Report",
      "JobID": 80,
      "JobName": "Removed Quota Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Retrieve Booking",
      "JobID": 86,
      "JobName": "Retrieve Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto Cancellations",
      "JobID": 92,
      "JobName": "Auto Cancellations",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Receipt Summary",
      "JobID": 95,
      "JobName": "Bus Receipt Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Shared Chart Coll",
      "JobID": 98,
      "JobName": "Shared Chart Coll",
      "RoleID": 23827
    },
    {
      "JobDescription": "Driver-Conductor Report",
      "JobID": 100,
      "JobName": "Driver-Conductor Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Guest Tickets",
      "JobID": 101,
      "JobName": "Guest Tickets",
      "RoleID": 23827
    },
    {
      "JobDescription": "Login Info",
      "JobID": 102,
      "JobName": "Login Info",
      "RoleID": 23827
    },
    {
      "JobDescription": "Routewise Collection",
      "JobID": 104,
      "JobName": "Routewise Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Collection Boy",
      "JobID": 106,
      "JobName": "Collection Boy",
      "RoleID": 23827
    },
    {
      "JobDescription": "Offline Collection",
      "JobID": 107,
      "JobName": "Offline Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Agent Recharge",
      "JobID": 108,
      "JobName": "Agent Recharge",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Summary(Datewise)",
      "JobID": 109,
      "JobName": "Userwise Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Finalize",
      "JobID": 110,
      "JobName": "Bus Finalize",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee Summary",
      "JobID": 111,
      "JobName": "Franchisee Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Pickup-NonReported",
      "JobID": 114,
      "JobName": "Pickup-NonReported",
      "RoleID": 23827
    },
    {
      "JobDescription": "Phone Bookings",
      "JobID": 117,
      "JobName": "Phone Bookings",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Bus Departure",
      "JobID": 118,
      "JobName": "Daily Bus Departure",
      "RoleID": 23827
    },
    {
      "JobDescription": "Return Booking",
      "JobID": 122,
      "JobName": "Return Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Advance Booking",
      "JobID": 125,
      "JobName": "Advance Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Booking",
      "JobID": 126,
      "JobName": "Userwise Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cancellation Charges",
      "JobID": 129,
      "JobName": "Cancellation Charges",
      "RoleID": 23827
    },
    {
      "JobDescription": "Offline Agent Tickets",
      "JobID": 130,
      "JobName": "Offline Agent Tickets",
      "RoleID": 23827
    },
    {
      "JobDescription": "Remarks(Stopbooking,booking,cancellation)",
      "JobID": 131,
      "JobName": "Remarks",
      "RoleID": 23827
    },
    {
      "JobDescription": "PhoneToCancel Bookings",
      "JobID": 132,
      "JobName": "PhoneToCancel Bookings",
      "RoleID": 23827
    },
    {
      "JobDescription": "Discount Booking",
      "JobID": 133,
      "JobName": "Discount Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Expense",
      "JobID": 134,
      "JobName": "Daily Expense",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cancellation Voucher",
      "JobID": 139,
      "JobName": "Cancellation Voucher",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Analysis Report",
      "JobID": 140,
      "JobName": "Daily Analysis Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Other Branch Booking",
      "JobID": 141,
      "JobName": "Other Branch Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Petty Cash Statement",
      "JobID": 144,
      "JobName": "Petty Cash Statement",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise Summary",
      "JobID": 152,
      "JobName": "Buswise Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Summary",
      "JobID": 153,
      "JobName": "Booking Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Chart Remarks",
      "JobID": 155,
      "JobName": "Chart Remarks",
      "RoleID": 23827
    },
    {
      "JobDescription": "Future Occupancy Report",
      "JobID": 157,
      "JobName": "Future Occupancy Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Ticket History",
      "JobID": 158,
      "JobName": "Ticket History",
      "RoleID": 23827
    },
    {
      "JobDescription": "Group Boarding Report",
      "JobID": 159,
      "JobName": "Group Boarding Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Hold Release",
      "JobID": 160,
      "JobName": "Hold Release",
      "RoleID": 23827
    },
    {
      "JobDescription": "Confirm/Cancel Bookings",
      "JobID": 163,
      "JobName": "Confirm/Cancel Bookings",
      "RoleID": 23827
    },
    {
      "JobDescription": "Return Ticket Branchwise",
      "JobID": 165,
      "JobName": "Return Ticket Branchwise",
      "RoleID": 23827
    },
    {
      "JobDescription": "Tripwise Income Summary",
      "JobID": 166,
      "JobName": "Tripwise Income Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Booking Activity",
      "JobID": 168,
      "JobName": "Userwise Booking Activity",
      "RoleID": 23827
    },
    {
      "JobDescription": "Tout and Roundoff Discount",
      "JobID": 167,
      "JobName": "Tout and Roundoff Discount",
      "RoleID": 23827
    },
    {
      "JobDescription": "Trip Block Dashboard",
      "JobID": 169,
      "JobName": "Trip Block Dashboard",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cancellation Refund Report",
      "JobID": 170,
      "JobName": "Cancellation Refund Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Booking Summary",
      "JobID": 172,
      "JobName": "Userwise Booking Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Report/NonReport Details",
      "JobID": 173,
      "JobName": "Report/NonReport Details",
      "RoleID": 23827
    },
    {
      "JobDescription": "Coupon Detail Report",
      "JobID": 180,
      "JobName": "Coupon Detail Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Tablet Assignment Report",
      "JobID": 234,
      "JobName": "Tablet Assignment Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Inspection Report",
      "JobID": 235,
      "JobName": "Inspection Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Concession Report",
      "JobID": 236,
      "JobName": "Concession Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Business Quick View",
      "JobID": 238,
      "JobName": "Business Quick View",
      "RoleID": 23827
    },
    {
      "JobDescription": "WayBill Summary Report",
      "JobID": 240,
      "JobName": "WayBill Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Distributor Shared Chart",
      "JobID": 244,
      "JobName": "Distributor Shared Chart",
      "RoleID": 23827
    },
    {
      "JobDescription": "Distributor Franchise Report",
      "JobID": 245,
      "JobName": "Distributor Franchise Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Distributor Agent Shared Chart",
      "JobID": 246,
      "JobName": "Distributor Agent Shared Chart",
      "RoleID": 23827
    },
    {
      "JobDescription": "Distributor Agent Franchise Report",
      "JobID": 247,
      "JobName": "Distributor Agent Franchise Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Bus Position",
      "JobID": 258,
      "JobName": "Daily Bus Position",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Booking Summary",
      "JobID": 259,
      "JobName": "Daily Booking Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Agent Booking Summary",
      "JobID": 260,
      "JobName": "Agent Booking Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Finished Chart",
      "JobID": 261,
      "JobName": "Finished Chart",
      "RoleID": 23827
    },
    {
      "JobDescription": "Self Cancellation Report",
      "JobID": 265,
      "JobName": "Self Cancellation Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Bus Report",
      "JobID": 266,
      "JobName": "Daily Bus Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Routewise Details",
      "JobID": 269,
      "JobName": "Routewise Details",
      "RoleID": 23827
    },
    {
      "JobDescription": "Tablets List",
      "JobID": 270,
      "JobName": "Tablets List",
      "RoleID": 23827
    },
    {
      "JobDescription": "Conductor Performance",
      "JobID": 271,
      "JobName": "Conductor Performance",
      "RoleID": 23827
    },
    {
      "JobDescription": "Conductors Daily Cash Collection",
      "JobID": 273,
      "JobName": "Conductors Daily Cash Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "OTP Log Report",
      "JobID": 281,
      "JobName": "OTP Log Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Competitor Analysis Report",
      "JobID": 282,
      "JobName": "Competitor Analysis Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Competitor Analysis Map",
      "JobID": 283,
      "JobName": "Competitor Analysis Map",
      "RoleID": 23827
    },
    {
      "JobDescription": "Directory Report",
      "JobID": 289,
      "JobName": "Directory Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Punbus Commission Report",
      "JobID": 291,
      "JobName": "Punbus Commission Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Connecting City Report",
      "JobID": 310,
      "JobName": "Connecting City Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Coupon Booking Details",
      "JobID": 311,
      "JobName": "Coupon Booking Details",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Schedule History",
      "JobID": 316,
      "JobName": "Bus Schedule History",
      "RoleID": 23827
    },
    {
      "JobDescription": "Modification Detail Report",
      "JobID": 317,
      "JobName": "Modification Detail Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cancel Chart Report",
      "JobID": 325,
      "JobName": "Cancel Chart Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Night Halt Report",
      "JobID": 332,
      "JobName": "Night Halt Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Distance Covered Report",
      "JobID": 333,
      "JobName": "Distance Covered Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Driver Report",
      "JobID": 334,
      "JobName": "Driver Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Route Assignment Report",
      "JobID": 335,
      "JobName": "Route Assignment Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Trip Summary Report",
      "JobID": 336,
      "JobName": "Trip Summary Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "GPS SMS Tracking",
      "JobID": 343,
      "JobName": "GPS SMS Tracking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Lat-Long Mismatch Report",
      "JobID": 344,
      "JobName": "Lat-Long Mismatch Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "RouteWise Average Report",
      "JobID": 345,
      "JobName": "RouteWise Average Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Payment Report",
      "JobID": 346,
      "JobName": "Bus Payment Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise booking summary Report",
      "JobID": 347,
      "JobName": "Buswise booking summary Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "One Day Report",
      "JobID": 353,
      "JobName": "One Day Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "BusWise HeadWise Summary Report",
      "JobID": 361,
      "JobName": "BusWise HeadWise Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Pickup/Dropoff ScheduleTime",
      "JobID": 404,
      "JobName": "Pickup/Dropoff ScheduleTime",
      "RoleID": 23827
    },
    {
      "JobDescription": "Sms and Email Report",
      "JobID": 412,
      "JobName": "Sms and Email Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Pickup/Dropoff Charge Report",
      "JobID": 419,
      "JobName": "Pickup/Dropoff Charge Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "ExpressCheckOut Report",
      "JobID": 423,
      "JobName": "ExpressCheckOut Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "QR Transaction",
      "JobID": 430,
      "JobName": "QR Transaction",
      "RoleID": 23827
    },
    {
      "JobDescription": "QR Settlement",
      "JobID": 431,
      "JobName": "QR Settlement",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quick View (New)",
      "JobID": 432,
      "JobName": "Quick View (New)",
      "RoleID": 23827
    },
    {
      "JobDescription": "Passenger Detail Report",
      "JobID": 435,
      "JobName": "Passenger Detail Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "BusWise ProprietorWise Summary",
      "JobID": 445,
      "JobName": "BusWise ProprietorWise Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Ticket Modify History",
      "JobID": 454,
      "JobName": "Ticket Modify History",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto-Pos Transcation",
      "JobID": 455,
      "JobName": "Auto-Pos Transcation",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto-Pos Settelment",
      "JobID": 456,
      "JobName": "Auto-Pos Settelment",
      "RoleID": 23827
    },
    {
      "JobDescription": "Credit Voucher Report",
      "JobID": 459,
      "JobName": "Credit Voucher Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "WayBill Expense Report",
      "JobID": 488,
      "JobName": "WayBill Expense Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Agent Tickets without GST Deductions",
      "JobID": 494,
      "JobName": "Agent Tickets without GSTDeduct",
      "RoleID": 23827
    },
    {
      "JobDescription": "Passenger Detail Report(India)",
      "JobID": 519,
      "JobName": "Passenger Detail Report(India)",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise Route Checklist (Kanker Roadways Pvt Ltd)",
      "JobID": 523,
      "JobName": "Buswise Route Checklist",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Collection V2",
      "JobID": 528,
      "JobName": "Userwise Collection V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "WayBill Report",
      "JobID": 529,
      "JobName": "WayBill Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Revenue Report",
      "JobID": 531,
      "JobName": "Revenue Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Report(RTS Web)",
      "JobID": 224,
      "JobName": "Booking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Report(Web)",
      "JobID": 225,
      "JobName": "Dispatch Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Received Report",
      "JobID": 85,
      "JobName": "Received Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Delivery Report(Web)",
      "JobID": 308,
      "JobName": "Delivery Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Refund Report",
      "JobID": 70,
      "JobName": "Refund Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Stock Report",
      "JobID": 69,
      "JobName": "Branch Stock Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "InTransit Luggage",
      "JobID": 71,
      "JobName": "InTransit Luggage",
      "RoleID": 23827
    },
    {
      "JobDescription": "Party Booking",
      "JobID": 68,
      "JobName": "Party Booking",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Transfer Report(without Grouping)Crystal",
      "JobID": 263,
      "JobName": "Branch Transfer Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Short or Damage Receipt(Web)",
      "JobID": 267,
      "JobName": "Short or Damage Receipt",
      "RoleID": 23827
    },
    {
      "JobDescription": "On Account Report",
      "JobID": 89,
      "JobName": "On Account Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Collection Report",
      "JobID": 91,
      "JobName": "Collection Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Receipt Report",
      "JobID": 113,
      "JobName": "Branch Receipt Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Buswise Earnings",
      "JobID": 116,
      "JobName": "Buswise Earnings",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Memo",
      "JobID": 138,
      "JobName": "Bus Memo",
      "RoleID": 23827
    },
    {
      "JobDescription": "Octroi Report",
      "JobID": 143,
      "JobName": "Octroi Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Memo Voucher",
      "JobID": 146,
      "JobName": "Bus Memo Voucher",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Memo Voucher Credit",
      "JobID": 147,
      "JobName": "Bus Memo Voucher Credit",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Register",
      "JobID": 149,
      "JobName": "Dispatch Register",
      "RoleID": 23827
    },
    {
      "JobDescription": "Receipt Register",
      "JobID": 150,
      "JobName": "Receipt Register",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Register",
      "JobID": 151,
      "JobName": "Booking Register",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Summary",
      "JobID": 191,
      "JobName": "Dispatch Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Hisab Summary",
      "JobID": 192,
      "JobName": "Hisab Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Tracking Report",
      "JobID": 193,
      "JobName": "Booking && Delivery Tracking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "To-Pay Destination",
      "JobID": 195,
      "JobName": "To-Pay Destination",
      "RoleID": 23827
    },
    {
      "JobDescription": "To-Pay Statement",
      "JobID": 196,
      "JobName": "To-Pay Statement",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cargo Un-Loading",
      "JobID": 197,
      "JobName": "Cargo Un-Loading",
      "RoleID": 23827
    },
    {
      "JobDescription": "In-Out Challan Details",
      "JobID": 198,
      "JobName": "In-Out Challan Details",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Summar Web",
      "JobID": 364,
      "JobName": "Booking Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Delivery Summary",
      "JobID": 201,
      "JobName": "Delivery Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "To-Pay Matching",
      "JobID": 203,
      "JobName": "To-Pay Matching",
      "RoleID": 23827
    },
    {
      "JobDescription": "Generate Hisab",
      "JobID": 204,
      "JobName": "Generate Hisab",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Booking Report",
      "JobID": 214,
      "JobName": "Daily Booking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Credit Limit Summary",
      "JobID": 216,
      "JobName": "Credit Limit Summary",
      "RoleID": 23827
    },
    {
      "JobDescription": "Credit Limit Transactions",
      "JobID": 217,
      "JobName": "Credit Limit Transactions",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Goods Balance Report",
      "JobID": 221,
      "JobName": "Booking Goods Balance Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Non-Movement Report",
      "JobID": 226,
      "JobName": "Non-Movement Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Debit/Credit Notes and Recharges",
      "JobID": 231,
      "JobName": "Debit/Credit Notes and Recharges",
      "RoleID": 23827
    },
    {
      "JobDescription": "Credit-Limit Usage",
      "JobID": 253,
      "JobName": "Credit-Limit Usage",
      "RoleID": 23827
    },
    {
      "JobDescription": "Party Credit-Limit Reports",
      "JobID": 262,
      "JobName": "Party Credit-Limit Reports",
      "RoleID": 23827
    },
    {
      "JobDescription": "Transit Delay Report",
      "JobID": 290,
      "JobName": "Transit Delay Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee Settlement Report",
      "JobID": 295,
      "JobName": "Franchisee Settlement Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee Pending Topay Report",
      "JobID": 297,
      "JobName": "Franchisee Pending Topay Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Inquiry Report",
      "JobID": 309,
      "JobName": "Booking Inquiry Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Reprint Report",
      "JobID": 312,
      "JobName": "Reprint Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Pending Topay Payment",
      "JobID": 313,
      "JobName": "Pending Topay Payment",
      "RoleID": 23827
    },
    {
      "JobDescription": "GST Report",
      "JobID": 321,
      "JobName": "GST Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Party Voucher Report",
      "JobID": 327,
      "JobName": "Party Voucher Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "User Activity Report",
      "JobID": 328,
      "JobName": "User Activity Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Franchisee ToPay Received",
      "JobID": 339,
      "JobName": "Franchisee ToPay Received",
      "RoleID": 23827
    },
    {
      "JobDescription": "Luggage Modification",
      "JobID": 349,
      "JobName": "Luggage Modification",
      "RoleID": 23827
    },
    {
      "JobDescription": "Luggage Missing Tracking",
      "JobID": 362,
      "JobName": "Luggage Missing Tracking",
      "RoleID": 23827
    },
    {
      "JobDescription": "FOC Booking Report",
      "JobID": 365,
      "JobName": "FOC Booking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branchwise Accounting",
      "JobID": 392,
      "JobName": "Branchwise Accounting",
      "RoleID": 23827
    },
    {
      "JobDescription": "EWay Bill Report",
      "JobID": 393,
      "JobName": "EWay Bill Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cargo Trip Report",
      "JobID": 394,
      "JobName": "Trip Report",
      "RoleID": 23827
    },
    {
      "JobDescription": " Handling Charges Report",
      "JobID": 399,
      "JobName": "Handling Charges Report",
      "RoleID": 23827
    },
    {
      "JobDescription": " Received ReportV2",
      "JobID": 400,
      "JobName": "Received ReportV2",
      "RoleID": 23827
    },
    {
      "JobDescription": " Quick ViewV2 ",
      "JobID": 402,
      "JobName": "Quick ViewV2",
      "RoleID": 23827
    },
    {
      "JobDescription": " GST Report Version 2 ",
      "JobID": 405,
      "JobName": "GST ReportV2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Collection Report Version 2",
      "JobID": 406,
      "JobName": "Collection ReportV2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cargo DashBoard",
      "JobID": 411,
      "JobName": "DashBoard",
      "RoleID": 23827
    },
    {
      "JobDescription": "DDDV Booking Report",
      "JobID": 414,
      "JobName": "DDDV Booking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "DDDV Pending Delivery",
      "JobID": 415,
      "JobName": "DDDV Pending Delivery",
      "RoleID": 23827
    },
    {
      "JobDescription": "BusWise Paid and ToPay Report",
      "JobID": 418,
      "JobName": "BusWise Paid and ToPay",
      "RoleID": 23827
    },
    {
      "JobDescription": " MonthlyBooking Report ",
      "JobID": 422,
      "JobName": "MonthlyBooking Report",
      "RoleID": 23827
    },
    {
      "JobDescription": " Monthly Target Report ",
      "JobID": 424,
      "JobName": "Monthly Target Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Weight Report",
      "JobID": 441,
      "JobName": "Weight Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Recharge LIT",
      "JobID": 444,
      "JobName": "Branch Recharge LIT",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Vehicle Report",
      "JobID": 447,
      "JobName": "Dispatch Vehicle Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Cargo And Bus Memo",
      "JobID": 448,
      "JobName": "Cargo And Bus Memo",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Branch CollectionV2",
      "JobID": 449,
      "JobName": "Daily Branch CollectionV2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Non-Movement Report V2",
      "JobID": 451,
      "JobName": "Non-Movement Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quickview Chartdate",
      "JobID": 460,
      "JobName": "Quickview Chartdate",
      "RoleID": 23827
    },
    {
      "JobDescription": "EwayBill Validity Report",
      "JobID": 482,
      "JobName": "EwayBill Validity Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Non-Movement Report V4",
      "JobID": 486,
      "JobName": "Non-Movement Report V4",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Report V2",
      "JobID": 457,
      "JobName": "Dispatch Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Transfer Report V2",
      "JobID": 462,
      "JobName": "Branch Transfer Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Branch Receipt Report V2",
      "JobID": 463,
      "JobName": "Branch Receipt Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Gst Report V3",
      "JobID": 466,
      "JobName": "Gst Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Delivery Report V2",
      "JobID": 467,
      "JobName": "Delivery Report V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dispatch Vehicle Report v2",
      "JobID": 468,
      "JobName": "Dispatch Vehicle Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Booking Summary V2",
      "JobID": 469,
      "JobName": "Booking Summary V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Daily Branch Collection V3",
      "JobID": 470,
      "JobName": "Daily Branch Collection",
      "RoleID": 23827
    },
    {
      "JobDescription": "Userwise Collection V2",
      "JobID": 472,
      "JobName": "Userwise Collection V2",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quick View Report V3",
      "JobID": 479,
      "JobName": "Quick View",
      "RoleID": 23827
    },
    {
      "JobDescription": "Quickview Chartdate V2",
      "JobID": 480,
      "JobName": "Quickview Chartdate",
      "RoleID": 23827
    },
    {
      "JobDescription": "EWayBill V2 Report",
      "JobID": 483,
      "JobName": "EWayBill V2 Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "On Account V2 Report",
      "JobID": 484,
      "JobName": "On Account V2 Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Party Booking V2 Report",
      "JobID": 485,
      "JobName": "Party Booking V2 Report",
      "RoleID": 23827
    },
    {
      "JobDescription": "Dashboard",
      "JobID": 489,
      "JobName": "Dashboard",
      "RoleID": 23827
    },
    {
      "JobDescription": "GST Report Return File",
      "JobID": 514,
      "JobName": "GST Report Return File",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto branch trans, dispatch receive",
      "JobID": 481,
      "JobName": "Auto Transaction",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto Receive",
      "JobID": 532,
      "JobName": "Auto Receive",
      "RoleID": 23827
    },
    {
      "JobDescription": "Auto Delivery",
      "JobID": 533,
      "JobName": "Auto Delivery",
      "RoleID": 23827
    },
    {
      "JobDescription": "Bus Booking",
      "JobID": 34,
      "JobName": "Bus Booking",
      "RoleID": 23827
    }
  ],
  "Status": "Success",
  "UserDetails": [
    {
      "Address": "Maven Operations Ahmedabad, Branch Office At Ahmedabad, Gujarat 380058, India",
      "AgentID": 7358,
      "AgentName": "Maven (dummy)",
      "AgentUserID": 49063,
      "AgentUserName": "MASTERUSER",
      "AllowDropoffCharge": "1",
      "AllowFullRefund": "0",
      "AllowPDChargeBBT": "1",
      "AllowPickupCharge": "1",
      "AllowSTax": "1",
      "BranchAddress": "Maven Operations Ahmedabad, Branch Office At Ahmedabad, Gujarat 380058, India",
      "BranchCityID": 1,
      "BranchCityName": "Ahmedabad",
      "BranchContactNo": "9999999999",
      "BranchID": 1,
      "BranchName": "Maven Operations Ahmedabad",
      "BranchStateID": 3,
      "BranchTypeID": "3",
      "BusCrsCheckSum": "kkApnnuNjZCZcG1Jbqr25QD40y9p9toY5g068fvtor7I8ZrGSZrbkOLN8+N0aXXlabrfdl1QJJCbQZiQ/wZ5QzdoJbGD2lyCxuxDRQ5/A4SdiEEhhGFMcONUzMnJYUBmSOlxAnwPYZ5/P8MIuzXe3g==",
      "CargoCommVoucherType": "M",
      "ChargeMode": "",
      "ColorCode": "102,255,255",
      "CompanyID": 1,
      "CompanyName": "_Maven Tech Services Pvt. Ltd.",
      "CompanyNameCargo": "_Maven Tech Services Pvt. Ltd.",
      "ConductorID": 0,
      "ConsiderForRent": "1",
      "EnableNonReportingAlerts": "0",
      "EzetapDemoAppkey": "",
      "EzetapDeviceUserName": "",
      "EzetapMerchantName": "",
      "EzetapProductionAppkey": "",
      "ForceWebBookingPage": "0",
      "GDSLogin": "",
      "GDSPassword": "",
      "GDSSubAgentCode": "6470",
      "GDSSubAgentLogin": "crs_dev",
      "HasGDSActive": "0",
      "HasGDSintoCRS": "1",
      "HasInternalSwiper": "0",
      "HasOnlineOfflineUWCMode": "1",
      "HasSeatWiseFareinBranch": "1",
      "HasVoucherAreaBinding": "1",
      "IsBranch": "0",
      "IsCancelRequestEnabled": "1",
      "IsCollBoyRequestPayment": "0",
      "IsGenerateCancelVoucher": "1",
      "IsMobileNoVerified": "0",
      "IsQBEnabled": "1",
      "IsQuotaBranch": "0",
      "IsSTACargoCompany": "1",
      "LoginID": "MASTER",
      "LoginToken": "W7k7v8M35WsvYok7RXHofTH5huLFCRkWuZABrwdnlj7lcLIo0cC1cFUL0pwDbVUzqZMUKdqI7Klvf1QpVEvlOp2SAUD+vjxeR/WicEBDK1MhFF5lfJr24ekdf+5Xs8+7",
      "MTPLAdminUser": "1",
      "MswipeMerchantPassword": "",
      "MswipeMerchantUserName": "",
      "PASSWORD": "Master@123",
      "PostponeAmount": 0,
      "PreponeAmount": 0,
      "ReportURL": "",
      "RestrictOldReport": "0",
      "RoleID": 23827,
      "SamedayAmount": 0,
      "ShowOnlineAgents": "1",
      "SpecialUser": "0",
      "TokenPassword": "d6dd0f4fe3371de21b5435aed357aa59",
      "UIsActive": "1",
      "UserID": 112684,
      "UserName": "MASTERUSER",
      "isAdmin": "0",
      "isBranchAdmin": "0",
      "isMTPLAdmin": "0",
      "isToutDiscount": "1"
    }
  ]
}

export const NUMERIC_DATA_TYPES = ['number', 'quantity', 'currency'];

export const DATETIME_FORMATTER = "DD-MMM-YY, ddd, hh:mm A";
export const DATE_FORMATTER = "DD-MMM-YY, ddd";
export const DATEONLY_FORMATTER = "DD-MMM-YY";

export const PDFHeadStyles = {
  fontSize: 10,
  halign: 'left',
  fillColor: [229, 243, 255],
  textColor: [0, 0, 0],
  valign: 'middle'
}

export const PDFBodyStyles = {
  fontSize: 10,
  textColor: [0, 0, 0],
  cellPadding: 2
}


export const pickUpDataPDF = {
  APIMavenGetPkpInquiryResult: {
    Table: [
      {
        PNRNo: "349388909-421",
        FromCity: "Jodhpur",
        FromCityShortName: "JDHPU",
        ToCity: "Pune",
        ToCityShortName: "PUNE",
        TicketNo: "421",
        TotalFare: 2000.00,
        FareSitting: 0.00,
        FareSlumber: 0.00,
        FareSleeper: 0.00,
        FareSittingAC: 0.00,
        FareSlumberAC: 0.00,
        FareSleeperAC: 2000.00,
        JourneyDate: "01-Apr-2025",
        PickupLocation: "Pickup Time:01:00 PM | Pickup Name:Mandi mode pali road 9829493219 -- 0291 - 2616458 , 2633837",
        CustomerName: "Nandan attal",
        AllSeats: "I",
        TotalSeatsCount: 1,
        OperatorName: "Shrinath Group Of Companies",
        BusType: "Air suspension packed glass",
        RouteName: "Jodhpur - Pune",
        SubRouteName: "Jodhpur - Pune",
        SubRouteNameShort: "JDHPU - PUNE",
        BookingStatus: "B",
        CustomerPhone1: "9785322008",
        CustomerPhone2: null,
        TypeofBookingCode: "AC",
        TypeofBooking: "AGENT CONFIRM",
        BookingDate: "01-Apr-2025",
        BookingTime: "11:12 AM",
        ReportDate: "11:49 AM 01-Apr-2025",
        PickupTimeOriginal: "2025-04-01T13:00:00"
      }
    ],
    Table1: [],
    Table2: [],
    Table3: []
  }
}
